import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Icon } from "@evertrue/et-components";

const DeviceSelector = ({ devices, selectedDevice, onDeviceChange, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    console.log(`${label} devices:`, devices);
    console.log(`Selected ${label} device:`, selectedDevice);
  }, [devices, selectedDevice, label]);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelectDevice = (deviceId) => {
    onDeviceChange(deviceId);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const foundDevice = devices.find((device) => device.deviceId === selectedDevice);
  // const selectedDeviceName = foundDevice
  //   ? foundDevice.label
  //   : `${label} ${devices.indexOf(foundDevice) + 1}`;

  return (
    <div className="device-selector" ref={dropdownRef}>
      <div className="device-selector-container">
        <button type="button" onClick={toggleDropdown} className="device-selector-trigger">
          <Icon icon={label.toLowerCase() === "microphone" ? "microphone-solid" : "tv-video"} iconKit="tv" />
          <Icon icon="chevron-down" iconKit="tv" className={`dropdown-arrow ${isOpen ? "open" : ""}`} />
        </button>
        {isOpen && (
          <ul className="device-selector-dropdown">
            {devices.map((device) => (
              <li
                key={device.deviceId}
                onClick={() => handleSelectDevice(device.deviceId)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleSelectDevice(device.deviceId);
                  }
                }}
                role="button"
                tabIndex={0}
                className={device.deviceId === selectedDevice ? "selected" : ""}
              >
                {device.label || `${label} ${devices.indexOf(device) + 1}`}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

DeviceSelector.propTypes = {
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      deviceId: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ).isRequired,
  selectedDevice: PropTypes.string.isRequired,
  onDeviceChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default DeviceSelector;
